import { apiClient } from '@/app/core/services/apiClient.service';
import { BaseApiService } from '@/app/shared/services/apis/baseApi.service';
import type { ApiResponse } from '@/app/shared/services/apis/types/ApiResponse';
import type { MainEvent } from '@/app/shared/services/apis/types/mainEvents/MainEvent';
import type { ID } from '@fifa-bsm/bo-frontend-shared/utils/types';
import type { AxiosResponse } from 'axios';

class mainEventsApiService extends BaseApiService {
    getList(page = 1, perPage = 100, params: Record<string, any>) {
        return this.client.get(`main-events`, { ...params, page, count: perPage });
    }

    getById(mainEventId: ID, { extended = false } = {}): Promise<ApiResponse<MainEvent>> {
        return this.client.get(`main-events/${mainEventId}`, {
            extended: extended ? true : undefined,
        });
    }

    create(data: any) {
        return this.client.post('main-events/store-by-guest-operations', data);
    }

    update(mainEventId: ID, data: any) {
        if (data instanceof FormData) {
            data.append('_method', 'PUT');
            return this.client.post(`main-events/${mainEventId}/update-by-guest-operations`, data);
        }

        return this.client.put(`main-events/${mainEventId}/update-by-guest-operations`, data);
    }

    getMainEventTypes() {
        return this.client.get(`main-event-types`);
    }

    getVenues(mainEventId: ID) {
        return this.client.get(`main-events/${mainEventId}/venues`);
    }

    getCollectionPoints(mainEventId: ID) {
        return this.client.get(`main-events/${mainEventId}/collecting-points`);
    }

    importETicketingBarcodes(mainEventId: ID, fileWithBarcodes: File) {
        const formData = new FormData();
        formData.set('file', fileWithBarcodes);
        return this.client.post(`main-events/${mainEventId}/eticketing/import`, formData);
    }

    async exportBarcodes(mainEventId: ID, payload: { password: string }) {
        return this.client.post(`main-events/${mainEventId}/eticketing/export-barcodes`, payload, {
            responseType: 'arraybuffer',
            mapResponse: (response: AxiosResponse<ArrayBuffer>) => response,
        });
    }
}

export const mainEventsApi = new mainEventsApiService(apiClient);
